import { render, staticRenderFns } from "./UpdateStock.vue?vue&type=template&id=c82cb5f4&"
import script from "./UpdateStock.vue?vue&type=script&lang=js&"
export * from "./UpdateStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports